// extracted by mini-css-extract-plugin
module.exports = {"root":"_1gVcLBf","suggestions":"_3KvSLpJ","didYouMean":"_3BK61T9","locationWrapper":"HQT1yRO","location":"_1O-Lp_1","or":"_3gkqlSR"};
    if(module.hot) {
      // 1545369435260
      var cssReload = require("!../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  